import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { IMotiv, IMotivForm, IMotivUpdatePayload } from '../motive-proiecte.interface';
import { MotiveProiecteService } from '../motive-proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-edit-motive-proiecte',
    templateUrl: './edit-motive-proiecte.component.html',
    styleUrls: ['./edit-motive-proiecte.component.scss']
})
export class EditMotiveProiecteComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: IMotiv,
        private dialogRef: MatDialogRef<EditMotiveProiecteComponent>,
        private motiveProiecteService: MotiveProiecteService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name } = this.form.value as IMotivForm;
        const payload: IMotivUpdatePayload = {
            id_motiv: this.data.id,
            name,
        };

        this.motiveProiecteService
            .updateMotiv(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
